import * as React from 'react';
import ListSubheader from '@material-ui/core/ListSubheader';

const CustomListSubheader = (props) => {
    return <ListSubheader {...props} />;
};

export { CustomListSubheader as ListSubheader };
